// extracted by mini-css-extract-plugin
export var bodyRow = "_hi-d";
export var cardColumns = "_hi-e";
export var ellipsesOverflow = "_hi-2";
export var flatBottomCorners = "_hi-3";
export var flatTopCorners = "_hi-4";
export var headerActionsDropdown = "_hi-f";
export var headerBottomRow = "_hi-c";
export var headerTopRow = "_hi-b";
export var orderDetailsWrapper = "_hi-0";
export var orderInfoContainer = "_hi-1";
export var productDetails = "_hi-9";
export var productImage = "_hi-5";
export var responsiveTable = "_hi-8";
export var shipmentContainer = "_hi-a";
export var tableBottomLeft = "_hi-6";
export var tableBottomRight = "_hi-7";
export var trackingLink = "_hi-g";